export const PRODUCTS_FETCHING = 'PRODUCTS_FETCHING';
export const PRODUCTS_SUCCESS = 'PRODUCTS_SUCCESS';
export const PRODUCTS_ERROR = 'PRODUCTS_ERROR';
export const PRODUCTS_INVALIDATE = 'PRODUCTS_INVALIDATE';
export const PRODUCTS_RESET = 'PRODUCTS_RESET';

export const PRODUCT_FETCHING = 'PRODUCT_FETCHING';
export const PRODUCT_SUCCESS = 'PRODUCT_SUCCESS';
export const PRODUCT_ERROR = 'PRODUCT_ERROR';
export const PRODUCT_INVALIDATE = 'PRODUCT_INVALIDATE';

export const PRODUCT_VARIATIONS_FETCHING = 'PRODUCT_VARIATIONS_FETCHING';
export const PRODUCT_VARIATIONS_SUCCESS = 'PRODUCT_VARIATIONS_SUCCESS';
export const PRODUCT_VARIATIONS_ERROR = 'PRODUCT_VARIATIONS_ERROR';
export const PRODUCT_VARIATIONS_INVALIDATE = 'PRODUCT_VARIATIONS_INVALIDATE';

export const IMAGE_FETCHING = 'IMAGE_FETCHING';
export const IMAGE_SUCCESS = 'IMAGE_SUCCESS';
export const IMAGE_ERROR = 'IMAGE_ERROR';
export const IMAGE_INVALIDATE = 'IMAGE_INVALIDATE';

export const IMAGES_FETCHING = 'IMAGES_FETCHING';
export const IMAGES_SUCCESS = 'IMAGES_SUCCESS';
export const IMAGES_ERROR = 'IMAGES_ERROR';
export const IMAGES_INVALIDATE = 'IMAGES_INVALIDATE';

export const PRODUCT_CHANGE_DELETE = 'PRODUCT_CHANGE_DELETE';
export const PRODUCT_CHANGE_UPDATE = 'PRODUCT_CHANGE_UPDATE';
export const SAVE_PRODUCT_CHANGES_FETCHING = 'SAVE_PRODUCT_CHANGES_FETCHING';
export const SAVE_PRODUCT_CHANGES_SUCCESS = 'SAVE_PRODUCT_CHANGES_SUCCESS';
export const SAVE_PRODUCT_CHANGES_ERROR = 'SAVE_PRODUCT_CHANGES_ERROR';
export const CLEAN_PRODUCT_CHANGES = 'CLEAN_PRODUCT_CHANGES';
export const CLEAN_PRODUCT_VARIATIONS_CHANGES = 'CLEAN_PRODUCT_VARIATIONS_CHANGES';
export const SAVE_PRODUCT_VARIATIONS_CHANGES_SUCCESS = 'SAVE_PRODUCT_VARIATIONS_CHANGES_SUCCESS';

export const SET_SCREEN_OPTIONS = 'SET_SCREEN_OPTIONS';
